export default {
    topics: [
        {
            title: ' add ',
            href: 'm-EntityCollection-add.html',
            attributes: { 'data-id': 'm-EntityCollection-add' },
            menu: { hasChildren: false },
            tocID: 'm-EntityCollection-add-d66e6741',
            topics: [],
        },
        {
            title: ' length ',
            href: 'p-EntityCollection-length.html',
            attributes: { 'data-id': 'p-EntityCollection-length' },
            menu: { hasChildren: false },
            tocID: 'p-EntityCollection-length-d66e6749',
            topics: [],
        },
        {
            title: ' remove ',
            href: 'm-EntityCollection-remove.html',
            attributes: { 'data-id': 'm-EntityCollection-remove' },
            menu: { hasChildren: false },
            tocID: 'm-EntityCollection-remove-d66e6757',
            topics: [],
        },
        {
            title: ' removeAll ',
            href: 'm-EntityCollection-removeAll.html',
            attributes: { 'data-id': 'm-EntityCollection-removeAll' },
            menu: { hasChildren: false },
            tocID: 'm-EntityCollection-removeAll-d66e6765',
            topics: [],
        },
    ],
};

